[
  [1,1,"Abdominal Wall (GIT)",0,0  ],
  [2,2,"Gastrcoschisis",1,0  ],
  [3,3,"Herniated viscera Bowel",2,0  ],
  [4,3,"Herniated viscera Liver",2,0  ],
  [5,3,"Herniated viscera Stomach",2,0  ],
  [6,3,"Herniated viscera Mesentery",2,0  ],
  [7,3,"Herniated viscera Heart",2,0  ],
  [8,2,"Onphalocelle (Exomphalos)",1,0  ],
  [9,3,"Bowel",8,0  ],
  [10,3,"Liver",8,0  ],
  [11,3,"Stomach",8,0  ],
  [12,3,"Mesentery",8,0  ],
  [13,3,"Bladder",8,0  ],
  [14,3,"Heart",8,0  ],
  [15,2,"Body Stalk anomaly",1,0  ],
  [16,2,"Bladder extrophy",1,0  ],
  [17,2,"Cloacal extrophy",1,0  ],
  [18,1,"Brain (CNS)",0,0  ],
  [19,2,"Anencephaly",18,0  ],
  [20,2,"Absent corpus callosum",18,0  ],
  [21,2,"Encephalocele",18,0  ],
  [22,3,"Occipital",21,0  ],
  [23,3,"Parietal",21,0  ],
  [24,3,"Frontal",21,0  ],
  [25,3,"ethomidal",21,0  ],
  [26,2,"Exencephaly",18,0  ],
  [27,2,"Holoprosencephaly",18,0  ],
  [28,3,"Alobar",27,0  ],
  [29,3,"Semilobar",27,0  ],
  [30,3,"Lobar",27,0  ],
  [31,2,"Iniencephaly",18,0  ],
  [32,2,"Ventriculomegaly/Hydrocephalus",18,0  ],
  [33,2,"Calcification",18,0  ],
  [34,2,"Dilated Cisterna Magna",18,0  ],
  [35,2,"Cysts",18,0  ],
  [36,3,"Arachnoid",35,0  ],
  [37,3,"Choroid Plexus Left",35,0  ],
  [38,3,"Choroid Plexus Right",35,0  ],
  [39,3,"Porencephalic",35,0  ],
  [40,3,"Posterior Fossa",35,0  ],
  [41,2,"Vermis Agenesis",18,0  ],
  [42,1,"Extermities (Skeleton)",0,0  ],
  [43,2,"Feet Abnormal",42,0  ],
  [44,3,"Absent",43,0  ],
  [45,3,"Adactyly",43,0  ],
  [46,3,"Brachydactyly",43,0  ],
  [47,3,"Clinodactyly",43,0  ],
  [48,3,"Cleft Foot/Toes",43,0  ],
  [49,3,"Oligodactyly",43,0  ],
  [50,3,"Overlapping Toes",43,0  ],
  [51,3,"Polydactyly",43,0  ],
  [52,3,"Rocker-bottom",43,0  ],
  [53,3,"Sandal gap",43,0  ],
  [54,3,"Talipes equinovarus (Clubfoot)",43,0  ],
  [55,2,"Humerus Abnormal",42,0  ],
  [56,3,"Short",55,0  ],
  [57,3,"Bowed",55,0  ],
  [58,3,"Fractured",55,0  ],
  [59,3,"Absent",55,0  ],
  [60,2,"Radius Abnormal",42,0  ],
  [61,3,"Short",60,0  ],
  [62,3,"Bowed",60,0  ],
  [63,3,"Fractured",60,0  ],
  [64,3,"Absent",60,0  ],
  [65,2,"Tibia Abnormal",42,0  ],
  [66,3,"Short",65,0  ],
  [67,3,"Bowed",65,0  ],
  [68,3,"Fractured",65,0  ],
  [69,3,"Absent",65,0  ],
  [70,2,"Joints Abnormal",42,0  ],
  [71,3,"Elbows fixed, flexed",70,0  ],
  [72,3,"Elbows fixed, extended",70,0  ],
  [73,3,"Elbows Abducted",70,0  ],
  [74,3,"Elbows Adducted",70,0  ],
  [75,3,"Wrists fixed, flexed",70,0  ],
  [76,3,"Wrists fixed, extended",70,0  ],
  [77,3,"Wrists Abducted",70,0  ],
  [78,3,"Wrists Adducted",70,0  ],
  [79,3,"Knees fixed, flexed",70,0  ],
  [80,3,"Knees fixed, extended",70,0  ],
  [81,3,"Knees Abducted",70,0  ],
  [82,3,"Knees Adducted",70,0  ],
  [83,3,"Ankles fixed, flexed",70,0  ],
  [84,3,"Ankles fixed, extended",70,0  ],
  [85,3,"Ankles Abducted",70,0  ],
  [86,3,"Ankles Adducted",70,0  ],
  [87,2,"Hand Abnormal",42,0  ],
  [88,3,"Absent",87,0  ],
  [89,3,"Adactyly",87,0  ],
  [90,3,"Archnodactyly",87,0  ],
  [91,3,"Brachydactyly",87,0  ],
  [92,3,"Clinodactyly",87,0  ],
  [93,3,"Cleft Hand/Finger",87,0  ],
  [94,3,"Olygodactyly",87,0  ],
  [95,3,"Overlapping fingers",87,0  ],
  [96,3,"Polydactyly",87,0  ],
  [97,3,"Syndactyly",87,0  ],
  [98,2,"Femur Abnormal",42,0  ],
  [99,3,"Short",98,0  ],
  [100,3,"Bowed",98,0  ],
  [101,3,"Fractured",98,0  ],
  [102,3,"Absent",98,0  ],
  [103,2,"Ulna Abnormal",42,0  ],
  [104,3,"Short",103,0  ],
  [105,3,"Bowed",103,0  ],
  [106,3,"Fractured",103,0  ],
  [107,3,"Absent",103,0  ],
  [108,2,"Fibula Abnormal",42,0  ],
  [109,3,"Short",108,0  ],
  [110,3,"Bowed",108,0  ],
  [111,3,"Fractured",108,0  ],
  [112,3,"Absent",108,0  ],
  [113,1,"Face & Neck",0,0  ],
  [114,2,"Cleft",113,0  ],
  [115,3,"Lip",114,0  ],
  [116,3,"Palate",114,0  ],
  [117,3,"Lip & Palate",114,0  ],
  [118,2,"Ears",113,0  ],
  [119,3,"Small",118,0  ],
  [120,3,"Low-lying",118,0  ],
  [121,2,"Eyes",113,0  ],
  [122,3,"Anophthalmia",121,0  ],
  [123,3,"Microphthalmia",121,0  ],
  [124,3,"Cyclops",121,0  ],
  [125,3,"Hypotelorism",121,0  ],
  [126,3,"Hypertelorism",121,0  ],
  [127,3,"Echodense lens",121,0  ],
  [128,2,"Flat Face",113,0  ],
  [129,2,"Macroglossia",113,0  ],
  [130,2,"Micrognathia",113,0  ],
  [131,2,"Nose",113,0  ],
  [132,3,"Absent",131,0  ],
  [133,3,"Hypoplastic",131,0  ],
  [134,3,"Proboscis",131,0  ],
  [135,3,"Singular nostril",131,0  ],
  [136,2,"Facial Tumour",113,0  ],
  [137,1,"Genitalia (GUT)",0,0  ],
  [138,2,"Hydrocoele",137,0  ],
  [139,2,"Hypospadia",137,0  ],
  [140,2,"Hydrometrocolpos",137,0  ],
  [141,1,"GIT (Digest)",0,0  ],
  [142,2,"Stomach",141,0  ],
  [143,3,"Not visible",142,0  ],
  [144,3,"Collapsed",142,0  ],
  [145,3,"Dilated",142,0  ],
  [146,3,"Duodenal artesia (Double Bubble)",142,0  ],
  [147,2,"Ascite",141,0  ],
  [148,3,"Mild",147,0  ],
  [149,3,"Moderate",147,0  ],
  [150,3,"Severe",147,0  ],
  [151,2,"Liver",141,0  ],
  [152,3,"Nodule",151,0  ],
  [153,3,"Hepatomegaly",151,0  ],
  [154,2,"Small Bowel",141,0  ],
  [155,3,"Small Bowel Obstruction",154,0  ],
  [156,2,"Spleen",141,0  ],
  [157,3,"Splenomegaly",156,0  ],
  [158,2,"Large Bowel",141,0  ],
  [159,3,"Large Bowel Obstruction",158,0  ],
  [160,2,"Situs inversus",141,0  ],
  [161,1,"Head (CNS)",0,0  ],
  [162,2,"Brachycephaly",161,0  ],
  [163,2,"Dolichocephaly",161,0  ],
  [164,2,"Microcephaly",161,0  ],
  [165,2,"Prominet forehead",161,0  ],
  [166,2,"Prominet Occiput",161,0  ],
  [167,2,"Cloverleaf Shape",161,0  ],
  [168,2,"Lemon sign",161,0  ],
  [169,2,"Strawberry sign",161,0  ],
  [170,1,"Heart (Chest&Cardio)",0,0  ],
  [171,2,"4 Chambers View",170,0  ],
  [172,2,"Coractaion",170,0  ],
  [173,2,"Transposition",170,0  ],
  [174,2,"Dilation",170,0  ],
  [175,3,"Mild",174,0  ],
  [176,3,"Moderate",174,0  ],
  [177,3,"Severe",174,0  ],
  [178,2,"Dysrhythmia",170,0  ],
  [179,2,"Ebsteins Anomaly",170,0  ],
  [180,2,"Fallots Tetralogy",170,0  ],
  [181,2,"Pericardial effusions",170,0  ],
  [182,3,"Mild",181,0  ],
  [183,3,"Moderate",181,0  ],
  [184,3,"Severe",181,0  ],
  [185,2,"Septal Defect",170,0  ],
  [186,3,"Artium-Ventricle",185,0  ],
  [187,3,"Ventricle",185,0  ],
  [188,2,"Uni-ventricular",170,0  ],
  [189,2,"Uni-articular",170,0  ],
  [190,2,"Acardia",170,0  ],
  [191,1,"Kidneys (GUT)",0,0  ],
  [192,2,"Hydronephrosis",191,0  ],
  [193,3,"Left",192,0  ],
  [194,3,"Right",192,0  ],
  [195,3,"Left & Right",192,0  ],
  [196,2,"Pyelectasis (Pelviectasis)",191,0  ],
  [197,2,"Multicystic",191,0  ],
  [198,3,"Left",197,0  ],
  [199,3,"Right",197,0  ],
  [200,3,"Left & Right",197,0  ],
  [201,3,"MCDK",197,0  ],
  [202,2,"Polycystic",191,0  ],
  [203,3,"Left",202,0  ],
  [204,3,"Right",202,0  ],
  [205,3,"Left & Right",202,0  ],
  [206,2,"Renal Agenesis",191,0  ],
  [207,3,"Left",206,0  ],
  [208,3,"Right",206,0  ],
  [209,3,"Left & Right",206,0  ],
  [210,2,"Pelvic Kidney",191,0  ],
  [211,3,"Left",210,0  ],
  [212,3,"Right",210,0  ],
  [213,3,"Left & Right",210,0  ],
  [214,2,"Ureters",191,0  ],
  [215,3,"Left",214,0  ],
  [216,3,"Right",214,0  ],
  [217,3,"Left & Right",214,0  ],
  [218,3,"Mega Ureter",214,0  ],
  [219,2,"Adrenal Glands",191,0  ],
  [220,3,"Adrenal Tumor",219,0  ],
  [221,3,"Adrenal Cyst",219,0  ],
  [222,1,"Neck&Skin (Face&Neck)",0,0  ],
  [223,2,"Nuchal thickening",222,0  ],
  [224,2,"Cystic Hygromas",222,0  ],
  [225,3,"Mild",224,0  ],
  [226,3,"Moderate",224,0  ],
  [227,3,"Severe",224,0  ],
  [228,2,"Generalised Oedema",222,0  ],
  [229,3,"Mild",228,0  ],
  [230,3,"Moderate",228,0  ],
  [231,3,"Severe",228,0  ],
  [232,2,"Tumor",222,0  ],
  [233,1,"Skeleton & Musculature",0,0  ],
  [234,2,"Intrauterine fractures",233,0  ],
  [235,2,"Skeletal Shortining",233,0  ],
  [236,2,"Thanatophoric dwarfism",233,0  ],
  [237,2,"Achondrogenesis",233,0  ],
  [238,2,"Ostogenesis imperfect",233,0  ],
  [239,2,"Camptomelic Dysplasia",233,0  ],
  [240,2,"Short Rib Short Limb Syndrome",233,0  ],
  [241,2,"Ellis Van Crefeld syndrome",233,0  ],
  [242,2,"Chondrodystrophic Dystrophy",233,0  ],
  [243,2,"Arthogryposis multiplex congentia",233,0  ],
  [244,1,"Spine (Skeleton)",0,0  ],
  [245,2,"Hemivertbra",244,0  ],
  [246,3,"Cervical",245,0  ],
  [247,3,"Thoracic",245,0  ],
  [248,3,"Lumbar",245,0  ],
  [249,3,"Sacral",245,0  ],
  [250,3,"segments",245,0  ],
  [251,2,"Kyphosis",244,0  ],
  [252,3,"Cervical",251,0  ],
  [253,3,"Thoracic",251,0  ],
  [254,3,"Lumbar",251,0  ],
  [255,3,"Sacral",251,0  ],
  [256,3,"segments",251,0  ],
  [257,2,"Sacral agenesis",244,0  ],
  [258,2,"Sacrococcygal Teratoma",244,0  ],
  [259,3,"I external",258,0  ],
  [260,3,"II mainly exterrnal",258,0  ],
  [261,3,"III mainly internal",258,0  ],
  [262,3,"IV Internal",258,0  ],
  [263,2,"Sirenomelia",244,0  ],
  [264,2,"Scoliosis",244,0  ],
  [265,3,"Cervical",264,0  ],
  [266,3,"Thoracic",264,0  ],
  [267,3,"Lumbar",264,0  ],
  [268,3,"Sacral",264,0  ],
  [269,3,"segments",264,0  ],
  [270,2,"Meningocelle (Spina bifida)",244,0  ],
  [271,3,"Cervical",270,0  ],
  [272,3,"Thoracic",270,0  ],
  [273,3,"Lumbar",270,0  ],
  [274,3,"Sacral",270,0  ],
  [275,3,"segments",270,0  ],
  [276,2,"Meningomyelocelle (Spina bifida)",244,0  ],
  [277,3,"Cervical",276,0  ],
  [278,3,"Thoracic",276,0  ],
  [279,3,"Lumbar",276,0  ],
  [280,3,"Sacral",276,0  ],
  [281,3,"segments",276,0  ],
  [282,2,"Arnold Chiari Malformation",244,0  ],
  [283,3,"Cerebellum absent",282,0  ],
  [284,3,"Cerebellum banana",282,0  ],
  [285,3,"Lemon shaped Head",282,0  ],
  [286,1,"Thorax (Chest&Cardio)",0,0  ],
  [287,2,"Bronchogenic Cysts",286,0  ],
  [288,3,"Left",287,0  ],
  [289,3,"Right",287,0  ],
  [290,3,"Left & Right",287,0  ],
  [291,2,"Cystic-adenomatoid malformation",286,0  ],
  [292,3,"Macrocystic",291,0  ],
  [293,3,"Microcystict",291,0  ],
  [294,2,"Congenital diagphragmatic hernia",286,0  ],
  [295,3,"Stomach",294,0  ],
  [296,3,"Bowel",294,0  ],
  [297,3,"Liver",294,0  ],
  [298,3,"Pancreas",294,0  ],
  [299,2,"Hydrothorax",286,0  ],
  [300,3,"Left",299,0  ],
  [301,3,"Right",299,0  ],
  [302,3,"Left & Right",299,0  ],
  [303,2,"Sequestration",286,0  ],
  [304,3,"Extralobar",303,0  ],
  [305,3,"Intralobar",303,0  ],
  [306,2,"Hypoplasia",286,0  ],
  [307,3,"Left",306,0  ],
  [308,3,"Right",306,0  ],
  [309,3,"Left & Right",306,0  ],
  [310,2,"Mediastinal Shift",286,0  ],
  [311,3,"Mild",310,0  ],
  [312,3,"Moderate",310,0  ],
  [313,3,"Severe",310,0  ],
  [314,1,"General",0,0  ],
  [315,2,"Conditions",314,0  ],
  [316,3,"Multiple Malformations",315,0  ],
  [317,3,"IUGR",315,0  ],
  [318,3,"MACROSOMIA",315,0  ],
  [319,3,"Fetal Anemia",315,0  ],
  [320,3,"Single Umbilical Artery",315,0  ],
  [321,2,"Soft Markers",314,0  ],
  [322,3,"Ecogenic Bowel",321,0  ],
  [323,3,"Ecogenic Intracardiac Focus",321,0  ],
  [324,3,"Pyelectasis",321,0  ],
  [325,3,"CPC (Choroid Plexus Cyst)",321,0  ],
  [326,3,"Short Femur",321,0  ],
  [327,3,"Short Humerus",321,0  ],
  [328,3,"Cervical Cyst",321,0  ],
  [329,3,"Enlarged Nuchal Fold",321,0  ],
  [330,3,"more than one Soft Marker",321,0  ],
  [331,1,"Gynaecology",0,1  ],
  [332,2,"Symptoms",331,1  ],
  [333,3,"RLQ Abdominal Pain-[789.03.1]",332,1  ],
  [334,3,"LLQ Abdominal Pain-[789.04]",332,1  ],
  [335,3,"Abdominal Pain-[789.00]",332,1  ],
  [336,3,"Diffuse Abdominal Pain-[789.03.2]",332,1  ],
  [337,3,"Round Ligament Pain-[789.00]",332,1  ],
  [338,3,"Postcoital Abdominal pain-[789.00]",332,1  ],
  [339,3,"Postcoital Bleeding-[626.7]",332,1  ],
  [340,3,"Fever-[646.83]",332,1  ],
  [341,3,"Dysmenorrhea-[625.3]",332,1  ],
  [342,3,"Mittelschmerz-[625.2]",332,1  ],
  [343,3,"Superficial Dyspareunia-[625.0.1]",332,1  ],
  [344,3,"Deep Dyspareunia-[625.0.2]",332,1  ],
  [345,3,"Chronic Pelvic Pain-[625.9]",332,1  ],
  [346,3,"Dysuria-[788.1]",332,1  ],
  [347,3,"Urinary Incontinence-[788.30]",332,1  ],
  [348,3,"Hematuria-[599.89]",332,1  ],
  [349,3,"Nausea and Vomiting-[787.01]",332,1  ],
  [350,3,"Vaginal Bleeding-[623.8.1]",332,1  ],
  [351,3,"Vaginal Discharge-[623.5]",332,1  ],
  [352,3,"Cervical Bleeding-[622.8]",332,1  ],
  [353,3,"Postcoital Bleeding-[626.7.1]",332,1  ],
  [354,3,"Menorrhagia-[626.2.1]",332,1  ],
  [355,3,"Metrorrhagia-[626.6.1]",332,1  ],
  [356,3,"Menometrorrhagia-[626.2.2]",332,1  ],
  [357,3,"Amenorrhea-[626.0.1]",332,1  ],
  [358,3,"Hypomenorrhea-[626.1]",332,1  ],
  [359,3,"DUB, Dysfunctional Uterine Bleeding-[626.8]",332,1  ],
  [360,3,"PMB, Post Menopausal Bleeding-[627.1.1]",332,1  ],
  [361,3,"Vulvar Pruritus-[698.1]",332,1  ],
  [362,3,"Anemia-[285.9]",332,1  ],
  [363,3,"Diarrhea-[787.91]",332,1  ],
  [364,3,"Constipation-[564.00]",332,1  ],
  [365,3,"Fecal Incontinence-[787.60]",332,1  ],
  [366,3,"Vulvar Ulcer-[616.50.2]",332,1  ],
  [367,3,"Wound Infection-[998.59.2]",332,1  ],
  [368,3,"POVH, Post Operative Hernia-[553.21]",332,1  ],
  [369,3,"Vaginismus-[625.1]",332,1  ],
  [370,3,"Hydronephrosis-[591]",332,1  ],
  [371,3,"Hydroureter-[593.5]",332,1  ],
  [372,3,"Endometriosis in Scar-[617.6]",332,1  ],
  [373,3,"Obesity-[278.00]",332,1  ],
  [374,2,"Inflammatory Disease",331,1  ],
  [375,3,"PID, Pelvic Inflammatory Disease-[614.9.1]",374,1  ],
  [376,3,"Recurrent Pelvic Inflammatory Disease-[614.9.2]",374,1  ],
  [377,3,"Pyosalpinx-[614.2.1]",374,1  ],
  [378,3,"TOA, Tuboovarian Abscess-[614.2.2]",374,1  ],
  [379,3,"Fitz-Hugh-Curtis Synrome - Perihepatitis-[099.56]",374,1  ],
  [380,3,"Douglas Abscess-[614.4.1]",374,1  ],
  [381,3,"Pelvic Abscess-[614.4.2]",374,1  ],
  [382,3,"Sactosalpinx-[614.1.2]",374,1  ],
  [383,3,"Peritonitis-[567.9]",374,1  ],
  [384,3,"Acute Appendicitis-[540.9]",374,1  ],
  [385,3,"UTI, Urinary Tract Infection-[599.0]",374,1  ],
  [386,3,"Infected Endometrioma-[617.9.3]",374,1  ],
  [387,3,"Pyelonephritis-[590.80]",374,1  ],
  [388,3,"Pyometra-[615.9.1]",374,1  ],
  [389,3,"Vulvitis-[615.10.2]",374,1  ],
  [390,3,"Vaginitis-[615.10.3]",374,1  ],
  [391,3,"Labial Abscess-[616.4.1]",374,1  ],
  [392,3,"Vulvar Abscess-[616.4.2]",374,1  ],
  [393,3,"Bartholin Abscess-[616.3]",374,1  ],
  [394,3,"Infected Hematoma-[998.12]",374,1  ],
  [395,3,"Infected Endometrioma-[617.9.3]",374,1  ],
  [396,3,"Vaginal Cuff Hematoma-[623.6.1]",374,1  ],
  [397,3,"Endometritis-[615.9.2]",374,1  ],
  [398,3,"Endomyometritis(Postpartum/Postabortion)-[670.04.2]",374,1  ],
  [399,3,"Mastitis Postpartum-[675.24.1]",374,1  ],
  [400,3,"Sepsis-[038.9]",374,1  ],
  [401,3,"Postoperative Infection-[998.59]",374,1  ],
  [402,3,"Fever and Leukocytosis-[288.9]",374,1  ],
  [403,3,"Acute Gastroenteritis-[009.0]",374,1  ],
  [404,2,"Pregnancy",331,1  ],
  [405,3,"Ectopic Pregnancy-[633.80.1]",404,1  ],
  [406,3,"Ruptured Ectopic Pregnancy-[633.80.3]",404,1  ],
  [407,3,"Cervical Pregnancy-[633.80.4]",404,1  ],
  [408,3,"Ovarian Pregnancy-[633.20]",404,1  ],
  [409,3,"Normal Vaginal Pregnancy-[650]",404,1  ],
  [410,3,"Failed Mifegyne-[638.9]",404,1  ],
  [411,3,"Twin Pregnancy-[651.00]",404,1  ],
  [412,3,"Heterotopic Pregnancy-[633.91]",404,1  ],
  [413,3,"Early Pregnancy - Unknown Location-[629.9]",404,1  ],
  [414,3,"Blighted Ovum-[631]",404,1  ],
  [415,3,"Residua Postabortion-[631]",404,1  ],
  [416,3,"Tubal Abortion, Most Probably-[633.10]",404,1  ],
  [417,3,"Early Missed Abortion-[632.2]",404,1  ],
  [418,3,"Late Missed Abortion-[632.2]",404,1  ],
  [419,3,"Early Induced Abortion-[635.90.1]",404,1  ],
  [420,3,"Late Induced Abortion-[635.90.1]",404,1  ],
  [421,3,"Incomplete Abortion-[634.91.1]",404,1  ],
  [422,3,"Spontaneous Complete Abortion-[634.92]",404,1  ],
  [423,3,"Threatened Abortion-[640.00]",404,1  ],
  [424,3,"Septic Abortion-[636.00]",404,1  ],
  [425,3,"Hydatidiform Mole-[630]",404,1  ],
  [426,3,"Residua Postpartum-[667.14]",404,1  ],
  [427,3,"Residua Postabortion-[631]",404,1  ],
  [428,3,"Placenta Previa-[641.00]",404,1  ],
  [429,3,"Subchorionic Hematoma-[641.23]",404,1  ],
  [430,3,"Pregnancy in Previous Cesarean Scar-[671.4]",404,1  ],
  [431,3,"Hyperemesis Gravidarum-[643.00]",404,1  ],
  [432,3,"Inevitable Abortion-[634.91.2]",404,1  ],
  [433,3,"Second Trimester Bleeding-[641.80]",404,1  ],
  [434,3,"UTI, Urinary Tract Infection-[599.0]",404,1  ],
  [435,3,"Pyelonephritis-[590.80]",404,1  ],
  [436,3,"Renal Colic-[788.0]",404,1  ],
  [437,3,"Hypertension Complicating Pregnancy-[642.90]",404,1  ],
  [438,3,"Headache in Pregnancy-[784.0]",404,1  ],
  [439,3,"Habitual Abortion-[646.30]",404,1  ],
  [440,3,"DIC, Disseminated Intravascular Coagulation-[286.6]",404,1  ],
  [441,3,"Amniotic Fluid Embolism-[673.10]",404,1  ],
  [442,3,"Amnionitis-[762.7]",404,1  ],
  [443,3,"Premature Contractions-[763.7]",404,1  ],
  [444,3,"PPROM-[658.10]",404,1  ],
  [445,3,"Trauma in Pregnancy-[665.93]",404,1  ],
  [446,3,"Intrauterine Pregnancy-[V22.1]",404,1  ],
  [447,2,"Puerperium",331,1  ],
  [448,3,"Puerperal Fever-[672.04]",447,1  ],
  [449,3,"Engorgement of Breast-[676.24]",447,1  ],
  [450,3,"Mastitis-[675.84]",447,1  ],
  [451,3,"UTI, Urinary Tract Infection-[646.64]",447,1  ],
  [452,3,"Thrombophlebitis-[671.24]",447,1  ],
  [453,3,"Residua, Unspecified-[667.14]",447,1  ],
  [454,3,"Endometritis/Endomyometritis-[670.04.1]",447,1  ],
  [455,3,"E-PPH, Early Postpartum Hemorrhage-[666.10]",447,1  ],
  [456,3,"L-PPH, Late Postpartum Hemorrhage-[666.20]",447,1  ],
  [457,3,"Anemia-[648.24]",447,1  ],
  [458,3,"Placental Site Bleeding-[666.10]",447,1  ],
  [459,3,"AVM, Arterio-Venous Malformation-[747.60]",447,1  ],
  [460,3,"Wound Infection-[674.30]",447,1  ],
  [461,3,"Broad Ligament Hematoma-[665.74.1]",447,1  ],
  [462,3,"Abdominal Wall Hematoma-[665.74.2]",447,1  ],
  [463,3,"Infected Hematoma-[998.59.1]",447,1  ],
  [464,3,"Postpartum Hypertension-[642.94]",447,1  ],
  [465,3,"Disruption of External Operation Wound-[998.32]",447,1  ],
  [466,3,"DVT, Deep Vein Thrombosis-[671.44]",447,1  ],
  [467,3,"Postpartum Fever-[672.0]",447,1  ],
  [468,2,"Adnexal findings",331,1  ],
  [469,3,"Simple Ovarian Cyst-[620.2.2]",468,1  ],
  [470,3,"Functional Ovarian Cyst-[620.2.3]",468,1  ],
  [471,3,"Hemorrhagic Corpus Luteum-[620.1]",468,1  ],
  [472,3,"Corpus Luteum Hemorrhage or Rupture-[620.1]",468,1  ],
  [473,3,"Corpus Luteum Cyst or Hematoma-[620.1]",468,1  ],
  [474,3,"Paraovarian Cyst-[752.11.1]",468,1  ],
  [475,3,"Ovarian Cyst-[620.2.1]",468,1  ],
  [476,3,"Dermoid Cysts-[220.1]",468,1  ],
  [477,3,"Endometrioma-[617.9.1]",468,1  ],
  [478,3,"Endometriosis-[617.9.2]",468,1  ],
  [479,3,"Serous Cystadenoma-[236.2]",468,1  ],
  [480,3,"Mucinous Cystadenoma-[236.2]",468,1  ],
  [481,3,"Sactosalpinx-[614.1]",468,1  ],
  [482,3,"Hydrosalpinx-[614.1.1]",468,1  ],
  [483,3,"Torsion of Adnexa-[620.5.1]",468,1  ],
  [484,3,"Torsion of Ovary-[620.5.2]",468,1  ],
  [485,3,"Torsion of Fallopian Tube-[620.5.3]",468,1  ],
  [486,3,"PCO, Polycystic Ovaries-[256.4]",468,1  ],
  [487,3,"Proximal Tubal Occlusion-[614.6.2]",468,1  ],
  [488,3,"Prophylactic BSO (BRCA+)-[V50.42]",468,1  ],
  [489,3,"Prolapse of Fallopian Tube-[620.4]",468,1  ],
  [490,2,"Vulvar and perineal pathology",331,1  ],
  [491,3,"Bartholins gland Abscess-[616.3]",490,1  ],
  [492,3,"Labial Abscess-[624.8]",490,1  ],
  [493,3,"Bartholin Cyst-[616.2]",490,1  ],
  [494,3,"Labial Cyst-[624.8.1]",490,1  ],
  [495,3,"Imperforate Hymen-[752.42.1]",490,1  ],
  [496,3,"Hymenal Bridge-[752.40.2]",490,1  ],
  [497,3,"Episiotomy Related Dyspareunia-[625.3]",490,1  ],
  [498,3,"Vulvar Sebaceous Cyst-[706.2]",490,1  ],
  [499,3,"Trichomonal Vulvovaginitis-[131.01]",490,1  ],
  [500,3,"Candidiasis of Vulva and/or Vagina-[112.1]",490,1  ],
  [501,3,"Vulvar Nevus-[448.1]",490,1  ],
  [502,3,"Chancroid-[099.0]",490,1  ],
  [503,3,"Skin Tag-[624.8.2]",490,1  ],
  [504,3,"Herpes Genitalis-[054.10]",490,1  ],
  [505,3,"Condyloma Acuminata-[078.11]",490,1  ],
  [506,3,"Veneral disease of the Lower Genitourinary Tract-[099.9]",490,1  ],
  [507,3,"Foreign Body in Vagina-[939.2]",490,1  ],
  [508,3,"Vulvar Ulcer-[616.50.2]",490,1  ],
  [509,3,"Kissing Ulcers-[616.50.1]",490,1  ],
  [510,3,"Lymphogranuloma Venereum-[099.1]",490,1  ],
  [511,3,"Vulvar Leukoplakia-[624.09]",490,1  ],
  [512,3,"Hypertrophy of Labia-Unilateral-[624.3]",490,1  ],
  [513,3,"Hypertrophy of Labia-Bilateral-[624.3]",490,1  ],
  [514,3,"Early menarche-[256.39.1]",490,1  ],
  [515,3,"Late menarche-[256.39.2]",490,1  ],
  [516,3,"Late menopause-[256.39.3]",490,1  ],
  [517,3,"Endometriosis-[617.9.4]",490,1  ],
  [518,3,"Sexual Assault-Adult-[995.83]",490,1  ],
  [519,3,"Sexual Assault-Child-[E967.9]",490,1  ],
  [520,2,"Benign Uterine Pathology",331,1  ],
  [521,3,"Thick Endometrium-[621.30]",520,1  ],
  [522,3,"Adenomyosis-[617.0]",520,1  ],
  [523,3,"Uterine Myomatosus-[218.9.1]",520,1  ],
  [524,3,"Hematometra-[621.4]",520,1  ],
  [525,3,"Pyometra-[615.9.1]",520,1  ],
  [526,3,"Myoma Nascens-[218.9.2]",520,1  ],
  [527,3,"Uterine Polyp-[621.0]",520,1  ],
  [528,3,"Retroversion Flexion-[621.6]",520,1  ],
  [529,3,"Allen-Masters (Universal Joint Syndrome)-[620.6]",520,1  ],
  [530,3,"Uterus Descensus-[618.1.2]",520,1  ],
  [531,3,"Elongatio Colli-[622.6.1]",520,1  ],
  [532,3,"Degenerated Myoma-[218.9.3]",520,1  ],
  [533,3,"Intraligamentary Myoma-[218.9.4]",520,1  ],
  [534,3,"Submucous Myoma-[218.0]",520,1  ],
  [535,3,"Intramural Myoma-[218.1]",520,1  ],
  [536,3,"Subserous Myoma-[218.2]",520,1  ],
  [537,3,"Intrauterine Adhesions-[621.5]",520,1  ],
  [538,3,"Ashermans Syndrome-[621.5]",520,1  ],
  [539,3,"Intraperitoneal Adhesions-[568.0]",520,1  ],
  [540,3,"PMB, Postmenopausal Bleeding-[627.1.2]",520,1  ],
  [541,3,"Perimenopausal Bleeding-[627.1]",520,1  ],
  [542,3,"IUD in situ-[996.65]",520,1  ],
  [543,3,"Lost IUD-[996.65]",520,1  ],
  [544,3,"Didelphic Uterus-[752.2]",520,1  ],
  [545,3,"Menorrhagia-[626.2.1]",520,1  ],
  [546,3,"Metrorrhagia-[626.6.1]",520,1  ],
  [547,3,"Amenorrhea-[626.0.1]",520,1  ],
  [548,3,"Menometrorrhagia-[626.2.2]",520,1  ],
  [549,3,"Pelvic Endometriosis-[617.9.3]",520,1  ],
  [550,3,"Simple Hyperplasia-[621.31]",520,1  ],
  [551,3,"Complex Hyperplasia-[621.32]",520,1  ],
  [552,3,"Perforation of Uterine Wall-[867.4]",520,1  ],
  [553,3,"Uterine Septum-[752.39]",520,1  ],
  [554,3,"Uterus Unicornis-[752.39]",520,1  ],
  [555,3,"Bicornuate Uterus-[752.39]",520,1  ],
  [556,3,"Bicornuate Non Communicating Uterus-[752.39]",520,1  ],
  [557,2,"S/P OBGYN Operations",331,1  ],
  [558,3,"S/P Cesarean Section-[654.20]",557,1  ],
  [559,3,"S/P Cervical Conization-[654.60]",557,1  ],
  [560,3,"S/P Trachelectomy-[654.60]",557,1  ],
  [561,3,"S/P TAH-[629.9]",557,1  ],
  [562,3,"S/P TAH+BSO-[629.9]",557,1  ],
  [563,3,"S/P Radical Hysterectomy-[629.9]",557,1  ],
  [564,3,"S/P Vaginal Hysterectomy-[629.9]",557,1  ],
  [565,3,"S/P Laparoscopic Hysterectomy-[629.9]",557,1  ],
  [566,3,"S/P Ovarian Cystectomy-[629.9]",557,1  ],
  [567,3,"S/P BSO-[629.9]",557,1  ],
  [568,3,"S/P Radiotherapy-[V67.1]",557,1  ],
  [569,3,"S/P Chemotherapy-[V67.1]",557,1  ],
  [570,3,"S/P Chemoradiation-[V67.51]",557,1  ],
  [571,3,"S/P Vulvectomy-[629.9]",557,1  ],
  [572,3,"S/P Vaginectomy-[629.9]",557,1  ],
  [573,3,"S/P Laparoscopic USO-[629.9]",557,1  ],
  [574,3,"S/P Laparoscopic BSO-[629.9]",557,1  ],
  [575,3,"S/P Laparoscopic Cystectomy-[629.9]",557,1  ],
  [576,3,"S/P Laparoscopic Detorsion of Adnexa-[620.5]",557,1  ],
  [577,3,"S/P Lap Salpingectomy due to EUP-[633.80]",557,1  ],
  [578,3,"S/P Ectopic Pregnancy-[633.80]",557,1  ],
  [579,3,"S/P D+C-[629.9]",557,1  ],
  [580,3,"S/P D+E-[629.9]",557,1  ],
  [581,3,"S/P TOP by Mifegyne + Cytotec-[779.6]",557,1  ],
  [582,3,"S/P Methotrexate Treatment-[760.78]",557,1  ],
  [583,3,"S/P IVF-[628.9]",557,1  ],
  [584,3,"S/P Ovulation Induction-[628.9]",557,1  ],
  [585,3,"S/P Appendectomy-[211.3]",557,1  ],
  [586,3,"S/P LN Dissection-[196.9]",557,1  ],
  [587,3,"S/P Ant Colporrhaphy-[629.9]",557,1  ],
  [588,3,"S/P Post Colporrhaphy-[629.9]",557,1  ],
  [589,3,"S/P TOT-[629.9]",557,1  ],
  [590,2,"S/P OBGYN Operations",331,1  ],
  [591,3,"Elongatio Colli-[622.6.1]",557,1  ],
  [592,3,"Uterine Prolapse-[618.1]",557,1  ],
  [593,3,"Uterus Descensus-[618.1.2]",557,1  ],
  [594,3,"Total Uterine Prolapse-[618.3]",557,1  ],
  [595,3,"Pelvic Organ Prolapse-[618.9]",557,1  ],
  [596,3,"Inversion of Vaginal Walls-[618.00.1]",557,1  ],
  [597,3,"Cystocele-[618.01.1]",557,1  ],
  [598,3,"Urethrocele-[618.03]",557,1  ],
  [599,3,"Rectocele-[618.04.1]",557,1  ],
  [600,3,"Enterocele-[618.6]",557,1  ],
  [601,3,"Recto-Enterocele-[618.04.2]",557,1  ],
  [602,3,"Vaginal Vault Prolapse-[618.5]",557,1  ],
  [603,3,"SUI, Stress Urinary Incontinence-[625.6.1]",557,1  ],
  [604,3,"Mixed Urinary Incontinence-[788.33]",557,1  ],
  [605,3,"Urgency Incontinence-[788.31]",557,1  ],
  [606,3,"Detrusor Overactivity-[596.59]",557,1  ],
  [607,3,"Urinary Retention-[788.20]",557,1  ],
  [608,3,"Vesico-Vaginal Fistula-[619.0.1]",557,1  ],
  [609,3,"Uretero-Vaginal Fistula-[619.0.2]",557,1  ],
  [610,3,"Urethrovaginal Fistula-[619.0]",557,1  ],
  [611,3,"Recto-Vaginal Fistula-[619.1]",557,1  ],
  [612,3,"Endometriosis of Rectovaginal Septum-[617.4]",557,1  ],
  [613,3,"Urethral Diverticulum-[599.2]",557,1  ],
  [614,3,"Bladder Outlet Obstruction-[596.0]",557,1  ],
  [615,3,"Roomy Vagina-[654.70]",557,1  ],
  [616,3,"Erosion of Mesh / Sling-[521.34]",557,1  ],
  [617,2,"Benign cervical and vaginal pathology",331,1  ],
  [618,3,"Cervical Polyp-[622.7]",617,1  ],
  [619,3,"Cervical Ectropion-[622.0]",617,1  ],
  [620,3,"Postcoital Bleeding-[626.7.1]",617,1  ],
  [621,3,"Malformed Cervix-[752.40.1]",617,1  ],
  [622,3,"Distorted Cervix-[622.4]",617,1  ],
  [623,3,"Cervical Stenosis-[622.4]",617,1  ],
  [624,3,"Decidual Polyp-[674.40]",617,1  ],
  [625,3,"CIN-I, Cervical Intraepithelial Neoplasia-[622.11]",617,1  ],
  [626,3,"CIN II, Cervical Intraepithelial Neoplasia-[622.12]",617,1  ],
  [627,3,"CIN-III, Cervical Intraepithelial Neoplasia-[233.1.3]",617,1  ],
  [628,3,"Cervical Incompetence-[622.5]",617,1  ],
  [629,3,"Portio Vaginalis Short, S/P Cervical Conization-[623.9.1]",617,1  ],
  [630,3,"Gartner Cyst-[752.41]",617,1  ],
  [631,3,"Vaginal Cuff Hematoma-[623.6.1]",617,1  ],
  [632,3,"Vaginal Thrombus-[665.74]",617,1  ],
  [633,3,"Septated Vagina-Longitudinal Septum-[752.49.1]",617,1  ],
  [634,3,"Septated Vagina-Transverse Septum-[752.49.3]",617,1  ],
  [635,3,"Imperforated Hymen-[752.42.1]",617,1  ],
  [636,3,"Vaginal Cyst, Unspecified-[752.41]",617,1  ],
  [637,3,"Intracervical Adhesions-[622.4]",617,1  ],
  [638,3,"Atrophic Vaginitis-[627.3]",617,1  ],
  [639,3,"Vaginal Tear-[623.4]",617,1  ],
  [640,3,"Vaginal Stenosis-[623.2]",617,1  ],
  [641,3,"Cervical Leiomyoma-[654.10]",617,1  ],
  [642,3,"LG-SIL, Low Grade Squamous Intraepithelial Lesion-[795.03]",617,1  ],
  [643,3,"HG-SIL, High Grade Squamous Intraepithelial Lesion-[795.04]",617,1  ],
  [644,2,"Malignancy of uterus",331,1  ],
  [645,3,"Endometrial Carcinoma-[182.0.2]",644,1  ],
  [646,3,"Unstaged Endometrial Carcinoma-[182.0.1]",644,1  ],
  [647,3,"Uterine Malignancy, NOS-[179.1]",644,1  ],
  [648,3,"Uterine Leiomyosarcoma-[179.3]",644,1  ],
  [649,3,"Mixed Mullerian Tumor of Uterus-[179.4]",644,1  ],
  [650,3,"Undifferentiated Sarcoma of Uterus-[179.5]",644,1  ],
  [651,3,"Low Grade Stromal Sarcoma of Uterus-[182.0.3]",644,1  ],
  [652,3,"Leiomyomatosis-[236.0]",644,1  ],
  [653,3,"Serous Papillary Endometrial Carcinoma-[182.0.4]",644,1  ],
  [654,3,"Endometrioid Endometrial Carcinoma-[182.0.5]",644,1  ],
  [655,2,"Malignancy of vulva and vagina",331,1  ],
  [656,3,"Vulvar Carcinoma-[184.4.2]",655,1  ],
  [657,3,"Microinvasive Vulvar Carcinoma-[184.4.3]",655,1  ],
  [658,3,"One-Sided Vulvar Carcinoma-[184.4.4]",655,1  ],
  [659,3,"Bilateral Vulvar Carcinoma-[184.4.5]",655,1  ],
  [660,3,"Carcinoma of Vulva Involving Clitoris-[184.4.1]",655,1  ],
  [661,3,"Vulvar Intraepithelial Neoplasia-[624.9]",655,1  ],
  [662,3,"Melanoma of Vulva-[184.4.6]",655,1  ],
  [663,3,"Malignant Neoplasm of Vulva-[184.4.7]",655,1  ],
  [664,3,"Malignancy of Vagina-[184.0.2]",655,1  ],
  [665,3,"Carcinoma of Vagina-[184.0.1]",655,1  ],
  [666,3,"Vaginal Intraepithelial Neoplasia-[623.0]",655,1  ],
  [667,2,"Malignancy of Cervix",331,1  ],
  [668,3,"Squamous Cell Carcinoma in situ of Cervix-[233.1.1]",667,1  ],
  [669,3,"Adenocarcinoma in situ of Cervix-[233.1.2]",667,1  ],
  [670,3,"Invasive Sqamous Cell Carcinoma of Cervix-[180.9.1]",667,1  ],
  [671,3,"Invasive Adenocarcinoma of Cervix-[180.9.2]",667,1  ],
  [672,3,"Localized Cervical Carcinoma-[180.9.3]",667,1  ],
  [673,3,"Metastatic Cervical Carcinoma-[198.82]",667,1  ],
  [674,3,"Microinvasive Cervical Carcinoma-[180.9.4]",667,1  ],
  [675,3,"Cervical Sarcoma-[180.9.5]",667,1  ],
  [676,3,"Cervical Carcinoma, S/P Neoadjuvant Chemotherapy-[180.9.6]",667,1  ],
  [677,3,"Cervical Carcinoma, S/P Chemoradiation-[180.9.7]",667,1  ],
  [678,2,"Infertility",331,1  ],
  [679,3,"Antepartum condition or complication-[651.73]",678,1  ],
  [680,2,"Pelvic tumor",331,1  ],
  [681,3,"Pelvic Tumor, Unspecified-[238.8]",680,1  ],
  [682,3,"Benign Ovarian Tumor-[220.2]",680,1  ],
  [683,3,"Pedunculated Myoma-[229.8]",680,1  ],
  [684,2,"Obstetrics",331,1  ],
  [685,3,"Dysfunctional Labor-[660.90]",684,1  ],
  [686,3,"Failed Induction-[660.90]",684,1  ],
  [687,3,"Arrest of Dilatation-[660.90]",684,1  ],
  [688,3,"Arrest of Decent-[660.90]",684,1  ],
  [689,3,"Prolonged Latent Phase-[660.90]",684,1  ],
  [690,3,"Prolonged Second Stage-[660.90]",684,1  ],
  [691,3,"Prolonged Deceleration Phase-[660.90]",684,1  ],
  [692,3,"Relative CPD-[653.40]",684,1  ],
  [693,3,"Non-Reassuring Fetal Heart Rate-[659.7]",684,1  ],
  [694,3,"Suspected Fetal Distress-[768.4]",684,1  ],
  [695,3,"Breech Presentation-[761.7]",684,1  ],
  [696,3,"Past Shoulder Dystocia-[660.40]",684,1  ],
  [697,3,"Previous Cesarean Section-[654.21]",684,1  ],
  [698,3,"Elective CS-[V50.9]",684,1  ],
  [699,3,"Transverse or Oblique Lie-[652.31]",684,1  ],
  [700,3,"Other Malposition or Malpresentation-[652.81]",684,1  ],
  [701,3,"Prolapse of Cord-[663.00]",684,1  ],
  [702,3,"PROM-[658.13]",684,1  ],
  [703,3,"Macrosomia-[656.60]",684,1  ],
  [704,3,"Suspected Macrosomia-[656.60]",684,1  ],
  [705,3,"Twin Pregnancy-[651.00]",684,1  ],
  [706,3,"Twin Pregnancy - 1st Non-Vertex-[651.00]",684,1  ],
  [707,3,"Placenta Previa-[641.00]",684,1  ],
  [708,3,"Complete Placenta Previa-[641.00]",684,1  ],
  [709,3,"Partial Placenta Previa-[641.00]",684,1  ],
  [710,3,"Marginal Placenta Previa-[641.00]",684,1  ],
  [711,3,"Low Lying Placenta-[641.00]",684,1  ],
  [712,3,"Bleeding Placenta Previa-[641.00]",684,1  ],
  [713,3,"Placental Abruption-[641.00]",684,1  ],
  [714,3,"Vasa Previa-[663.50]",684,1  ],
  [715,3,"Previous LSTCS-[654.20]",684,1  ],
  [716,3,"Previous Cesarean Section-[654.20]",684,1  ],
  [717,3,"Previous Corporeal Cesarean Section-[654.20]",684,1  ],
  [718,3,"Suspected Chorioamnionitis-[658.40]",684,1  ],
  [719,3,"Genital Herpes-[054.10]",684,1  ],
  [720,3,"GDMA1-[648.8]",684,1  ],
  [721,3,"GDMA2-[648.8]",684,1  ],
  [722,3,"IUGR-[764.9]",684,1  ],
  [723,3,"PPROM-[658.13]",684,1  ],
  [724,3,"Active Labor-[V22.2]",684,1  ]
]